import {
  configureStore,
  createListenerMiddleware,
  isAnyOf,
} from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import debounce from "lodash-es/debounce";
// common
import authReducer from "./Slices/Common/Auth/reducers/authSlice";
import userReducer, {
  setSelectedModule,
  setSelectedSemester,
} from "./Slices/Common/User/reducers/userSlice";
import alertReducer from "./Slices/Common/Alerts/alertsSlice";
import academicYearReducer from "./Slices/Common/AcademicYear/academicYear.slice";
import financialYearReducer from "./Slices/Common/FinancialYear/financialYear.slice";
import branchReducer from "./Slices/Admin/branchs/branch.slice";
import sendEmailReducer from "./Slices/Common/SendPDFEmail/sendEmailSlice";

// admin
import adminDashboardReducer from "./Slices/Admin/Dashboard/adminDashboardSlice";
import financialCategoryReducer from "./Slices/Finance/Category/financeCategory.Slice";
import financeConfigurationReducer from "./Slices/Finance/Configuration/configuration.slice";
import inventoryReducer from "./Slices/Finance/inventory/inventory.slice";
import budgetReducer from "./Slices/Finance/budget/budget.slice";
import entityReducer from "./Slices/Finance/entitie/entity.slice";
import entityRevenueReducer from "./Slices/Finance/EntityRevenue/EntityRevenue.slice";
import classReducer from "./Slices/Admin/Class/reducer/classSlice";
import semesterReducer from "./Slices/Admin/Class/Semester/semesterSlice";
import applicationRequestsReducer from "./Slices/Admin/ApplicationRequests/applicationRequestsSlice";
import subjectReducer from "./Slices/Admin/Class/Subject/subjectSlice";
import staffAttendanceReducer from "./Slices/Admin/staffAttendance/staffAttendance.slice";
import adminEventReducer from "./Slices/Admin/NoticeBoard/Events/eventSlice";
import adminNoticeReducer from "./Slices/Admin/NoticeBoard/Notice/noticeSlice";
import adminPageReducer from "./Slices/Admin/Class/Page/pageSlice";
import adminDiscussionReducer from "./Slices/Admin/Class/Discussion/discussionSlice";
import allstaffReducer from "./Slices/Admin/Users/Staff/staffSlice";
import receiptsReducer from "./Slices/Finance/Receipts/receiptsSlice";
import quotationReducer from "./Slices/Finance/Quotations/quotationSlice";
import adminDiscussionCommentsReducer from "./Slices/Admin/Class/Discussion/Comments/discussionCommentsSlice";
import adminClassIconsReducer from "./Slices/Admin/Class/reducer/iconSlice";
import rbacReducer from "./Slices/Common/RBAC/rbacSlice";
import admissonAttachmentReducer from "./Slices/Admin/Admission/admissionSlice";
import earnignsReducer from "./Slices/Finance/Earnings/earningsSlice";
import operationalExpensesReducer from "./Slices/Finance/operationalExpenses/operationalExpenses.slice";
import payrollReducer from "./Slices/Finance/payroll/payroll.slice";
import certificatesReducer from "./Slices/Admin/certificateAndLetterManagement/certificateAndLetterManagement.slice";
import signatureReducer from "./Slices/Admin/signatures/signature.slice";
import stampReducer from "./Slices/Admin/stamps/stamp.slice";
import jobPostingReducer from "./Slices/Admin/jobPosting/jobPostingSlice";
import jobApplicationReducer from "./Slices/Admin/jobApplication/jobApplicationSlice";
import investmentReducer from "./Slices/Finance/investments/investment.slice";
import liabilitiesReducer from "./Slices/Finance/liabilities/liabilities.slice";
import financialStatementsReducer from "./Slices/Finance/financialStatements/financialStatements.slice";
import fixedAssetsReducer from "./Slices/Finance/fixedAssets/fixedAssets.slice";
import cashFlowReducer from "./Slices/Finance/cashFlow/cashFlow.slice";

import documentReducer from "./Slices/Admin/DocumentsManagement/documents.slice";

import benefitsReducer from "./Slices/Admin/benifits/benifitSlice";
import visitorReducer from "./Slices/Admin/visitorManagement/visitor.slice";
import projectManagementReducer from "./Slices/Admin/projectManagement/projectManagement.slice";
// student
import studentAnnouncementReducer from "../Store/Slices/Student/Noticeboard/noticeSlice";
import studentEventReducer from "../Store/Slices/Student/Noticeboard/eventsSlice";
import studentClassReducer from "../Store/Slices/Student/MyClass/Class/classSlice";
// import studentClassTeacherReducer from "../Store/Slices/Student/MyClass/Class/classTeacher/classTeacherSlice";
// import studentClassmateReducer from "../Store/Slices/Student/MyClass/Class/classMates/classmateSlice";
import studentSubjectReducer from "../Store/Slices/Student/MyClass/Class/Subjects/subjectSlice";
import studentPagesReducer from "../Store/Slices/Student/MyClass/Class/Subjects/Pages/pagesSlice";
import studentDiscussionReducer from "../Store/Slices/Student/MyClass/Class/Subjects/Discussion/discussionSlice";
import studentSemesterReducer from "../Store/Slices/Student/MyClass/Class/semester/semesterSlice";
import studentApplicationReducer from "./Slices/Student/applications/application.slice";

// transportation
import transportRouteReducer from "../Store/Slices/Transportation/RoutesManagment/routeSlice";
import transportVehicleReducer from "../Store/Slices/Transportation/Vehicles/vehiclesSlice";
import transportShiftReducer from "../Store/Slices/Transportation/Shift/shiftSlice";
import transportScheduleReducer from "../Store/Slices/Transportation/Schedule/scheduleSlice";

import transportSubRouteReducer from "../Store/Slices/Transportation/SubRoute/subRouteSlice";
import transportVDAssignmentReducer from "../Store/Slices/Transportation/vehicleDriverAssignment/vehicleDriverAssignmentSice";
import transportDriverReducer from "../Store/Slices/Transportation/Driver/driver.slice";
import vehicleUserAssignmentReducer from "../Store/Slices/Transportation/VehiclePersonAssignment/vehiclePersonAssignmentSlice";
import transportHelperReducer from "../Store/Slices/Transportation/Helper/helperSlice";
import tripExecutionLogReducer from "../Store/Slices/Transportation/TripExecutionLog/tripExecutionLogSlice";
import { fetchClassDiscussions } from "./Slices/Admin/Class/Discussion/discussionThunks";
import { fetchAllPages } from "./Slices/Admin/Class/Page/pageThunk";

const authPersistConfig = {
  key: "auth",
  storage,
  whitelist: [
    "isLoggedIn",
    "role",
    "AcademicYear",
    "token",
    "selectedLanguage",
    "userRoles",
    "permissions",
  ],
};
const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  matcher: isAnyOf(setSelectedSemester),
  effect: async (action, api) => {
    const { id: semesterId } = action.payload || {};
    if (!semesterId) return;

    const state = api.getState();

    const cid =
      state.common.user.classInfo.selectedClassId ||
      state.admin.class.classDetails?._id;

    const sid = state.common.user.subjectInfo?.selectedSubjectId || null;

    if (!cid || !sid) {
      const parts = window.location.pathname.split("/");
      if (parts[1] === "class") {
        cid = cid || parts[2];
        sid = sid || (parts.length > 4 ? parts[3] : null);
      }
    }

    if (!cid) return;

    if (sid) {
      api.dispatch(fetchClassDiscussions({ cid, sid }));
      api.dispatch(fetchAllPages({ cid }));
    }

    localStorage.setItem("activeSemesterId", semesterId);
  },
});

const userPersistConfig = {
  key: "user",
  storage,
};

const semesterPersistConfig = {
  key: "semesters",
  storage,
  whitelist: ["semesters", "selectedSemester"],
};

const stdSubjectPersistConfig = {
  key: "stdSubject",
  storage,
  whitelist: ["subject"],
};

const stdClassPersistConfig = {
  key: "studentClass",
  storage,
};

const commonReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  user: persistReducer(userPersistConfig, userReducer),
  alertMsg: alertReducer,
  academicYear: academicYearReducer,
  financialYear: financialYearReducer,
  branchs: branchReducer,
  sendEmail: sendEmailReducer,
});

const AdminReducer = combineReducers({
  adminDashboard: adminDashboardReducer,
  class: classReducer,
  semesters: persistReducer(semesterPersistConfig, semesterReducer),
  subject: subjectReducer,
  staffAttendance: staffAttendanceReducer,
  events: adminEventReducer,
  notice: adminNoticeReducer,
  pages: adminPageReducer,
  discussions: adminDiscussionReducer,
  discussionComments: adminDiscussionCommentsReducer,
  classIcons: adminClassIconsReducer,
  quotations: quotationReducer,
  receipts: receiptsReducer,
  all_staff: allstaffReducer,
  financialCategory: financialCategoryReducer,
  configuration: financeConfigurationReducer,
  inventory: inventoryReducer,
  inventory: inventoryReducer,
  entity: entityReducer,
  entityRevenue: entityRevenueReducer,
  budget: budgetReducer,
  payroll: payrollReducer,
  operationalExpenses: operationalExpensesReducer,
  admissionAttachment: admissonAttachmentReducer,
  rbac: rbacReducer,
  earnings: earnignsReducer,
  applicationRequests: applicationRequestsReducer,
  certificates: certificatesReducer,
  signatures: signatureReducer,
  stamps: stampReducer,
  documents: documentReducer,
  benefits: benefitsReducer,
  visitor: visitorReducer,
  project: projectManagementReducer,
  jobPosting: jobPostingReducer,
  jobApplications: jobApplicationReducer,
  investment: investmentReducer,
  liabilities: liabilitiesReducer,
  financialStatements: financialStatementsReducer,
  fixedAssets: fixedAssetsReducer,
  cashFlow: cashFlowReducer,
});

const studentReducer = combineReducers({
  studentAnnouncement: studentAnnouncementReducer,
  studentEvent: studentEventReducer,
  studentApplication: studentApplicationReducer,
  studentClass: persistReducer(stdClassPersistConfig, studentClassReducer),
  studentSubject: persistReducer(
    stdSubjectPersistConfig,
    studentSubjectReducer
  ),
  studentPages: studentPagesReducer,
  studentDiscussion: studentDiscussionReducer,
  semesters: persistReducer(semesterPersistConfig, studentSemesterReducer),
});

const transportReducer = combineReducers({
  transportRoute: transportRouteReducer,
  transportVehicle: transportVehicleReducer,
  transportShift: transportShiftReducer,
  transportSubRoute: transportSubRouteReducer,
  transportVDAssignment: transportVDAssignmentReducer,
  transportSchedule: transportScheduleReducer,
  transportDriver: transportDriverReducer,
  vehicleUserAssignment: vehicleUserAssignmentReducer,
  transportHelper: transportHelperReducer,
  tripExecutionLog: tripExecutionLogReducer,
});

const store = configureStore({
  reducer: {
    common: commonReducer,
    admin: AdminReducer,
    devTools: false,
    student: studentReducer,
    transportation: transportReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).prepend(listenerMiddleware.middleware),
});

const persistor = persistStore(store);

export { store, persistor };
